var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4168 5.49984H4.5835C4.07724 5.49984 3.66683 5.91024 3.66683 6.4165V17.4165C3.66683 17.9228 4.07723 18.3332 4.5835 18.3332H17.4168C17.9231 18.3332 18.3335 17.9228 18.3335 17.4165V6.4165C18.3335 5.91024 17.9231 5.49984 17.4168 5.49984ZM4.5835 3.6665C3.06471 3.6665 1.8335 4.89772 1.8335 6.4165V17.4165C1.8335 18.9353 3.06471 20.1665 4.5835 20.1665H17.4168C18.9356 20.1665 20.1668 18.9353 20.1668 17.4165V6.4165C20.1668 4.89772 18.9356 3.6665 17.4168 3.6665H4.5835Z",
    fill: "#CACCD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 11C8.66041 11 8.25 11.4104 8.25 11.9167C8.25 12.4229 8.66041 12.8333 9.16667 12.8333H15.5833C16.0896 12.8333 16.5 12.4229 16.5 11.9167C16.5 11.4104 16.0896 11 15.5833 11H9.16667ZM6.41667 14.6667C5.91041 14.6667 5.5 15.0771 5.5 15.5833C5.5 16.0896 5.91041 16.5 6.41667 16.5H11.9167C12.4229 16.5 12.8333 16.0896 12.8333 15.5833C12.8333 15.0771 12.4229 14.6667 11.9167 14.6667H6.41667Z",
    fill: "#CACCD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41667 1.8335C5.91041 1.8335 5.5 2.2439 5.5 2.75016V6.41683C5.5 6.92309 5.91041 7.3335 6.41667 7.3335C6.92293 7.3335 7.33333 6.92309 7.33333 6.41683V2.75016C7.33333 2.2439 6.92293 1.8335 6.41667 1.8335ZM15.5833 1.8335C15.0771 1.8335 14.6667 2.2439 14.6667 2.75016V6.41683C14.6667 6.92309 15.0771 7.3335 15.5833 7.3335C16.0896 7.3335 16.5 6.92309 16.5 6.41683V2.75016C16.5 2.2439 16.0896 1.8335 15.5833 1.8335Z",
    fill: "#CACCD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.bf5b5192.svg";
export { ForwardRef as ReactComponent };